module.exports = __webpack_public_path__ + "static/media/006.373e6fd9.jpg";